import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	min-height: 56px;
	display: flex;
	align-items: center;
	padding-right: 16px;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
`;

export const InfoWrapper = styled.div`
	font-size: 13px;
	letter-spacing: 0.3px;
	color: ${colors.grey5};
	margin-left: auto;
	display: flex;
	align-items: center;
`;

export const ButtonsWrapper = styled.div`
	display: flex;

	button {
		margin-left: 8px;
	}
`;

export const ColorSymbol = styled.div`
	min-width: 9px;
	max-width: 9px;
	min-height: 9px;
	max-height: 9px;
	background-color: ${({ color }) => color};
	border-radius: 50%;
	margin-right: 2px;
`;

export const ItemWrapper = styled.div`
	display: flex;
	color: ${colors.grey5};
	font-size: 11px;
	align-items: center;
	padding-left: 9px;
`;

export const IconWrapper = styled.div`
	display: flex;
	align-items: center;
	height: 100%;
	margin-left: 8px;
`;

export const TooltipContent = styled.div`
	padding: 16px;
	min-width: 344px;
	max-width: 400px;
	display: flex;
	flex-direction: column;
`;

export const TooltipRow = styled.div`
	display: flex;
	align-items: center;
	font-weight: 500;
	font-size: 16px;
	color: ${colors.grey8};
	letter-spacing: 0.3px;
	min-height: 28px;

	${ColorSymbol} {
		min-width: 8px;
		max-width: 8px;
		min-height: 8px;
		max-height: 8px;
		margin-right: 9px;
	}
`;

export const TextWrapper = styled.div`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;

export const RightColumn = styled.div`
	margin-left: auto;
	padding-left: 16px;
`;
